export default __webpack_public_path__ + "static/media/Long Orange.b5554090.png";